<template>
  <auth-layout>
    <ValidationObserver ref="obs">
      <form @submit.prevent="submit()" class="text-xs-center" ref="form">
              <v-alert v-if="error" outlined color="red">{{error}}</v-alert>

      <ValidationProvider name="Email" rules="required|email">
            <v-text-field
              slot-scope="{
                errors,
                valid
              }"
              :error-messages="errors"
              :success="valid"
          outline
          name="email"
          label="Email address"
          type="email"
          v-model="user.email"
          append-icon="mdi-email"
          required
        ></v-text-field>
      </ValidationProvider>
        <v-row>
          <v-col>
            <v-btn
              block
              router
              :loading="$store.state.fetching"
              :to="{name: 'app.login'}"
            >{{$t('app.signin')}}</v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              color="primary"
              type="submit"
              :loading="$store.state.fetching"
            >{{$t('app.send')}}</v-btn>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
      <v-snackbar v-model="snack" :timeout="3000" color="success">
        {{ $t("app.mail_sent") }}
        <v-btn text @click="snack = false">{{$t('app.close')}}</v-btn>
      </v-snackbar>
  </auth-layout>
</template>
<script>
import AuthLayout from "./AuthLayout";
import { firebase } from "@firebase/app";
import "@firebase/auth";
import { mapActions } from "vuex";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "ForgotPassword",
  components: { AuthLayout, ValidationProvider, ValidationObserver },
  data() {
    return {
        error: "",
      user: { email: ""},
      snack : false,
    };
  },
  mounted() {
  
  },
  methods: {
    ...mapActions(["setUser", "toogleFetching", "updateAvatar","updateSnack"]),
    async submit() {
      const result = await this.$refs.obs.validate();
      if (result) {
        this.toogleFetching();
        firebase.auth().sendPasswordResetEmail(this.user.email).then(() => {
           this.toogleFetching();
           this.snack = true
        }).catch(err => {
               this.toogleFetching();
               this.setAuthError(err.code)
        })
    
      }
    },
    setAuthError(code) {
      switch (code) {
        case "auth/user-not-found":
          this.error = this.$t("app.user_not_found");
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.l-auth__user-icon {
  font-size: 8rem;
}
</style>